









































import { GPageBase } from '@/mixins';
import { mixins } from 'vue-class-component';
import { Component, Prop } from 'vue-property-decorator';
import GJgrowEventCreateFormFormat from '../GJgrowEventCreateFormFormat.vue';
import { required } from 'vuelidate/lib/validators';
import { jgrowEventCreateModule } from '@/store/modules/frames/jgrow-event-create.module';
import { EventParam } from '@/models/jgrow/event-param';
import GVTag from '@/components/GVTag.vue';
import moment from 'moment';
import { globalModule } from '@/store/modules/global.module';

@Component({
  name: 'GJgrowEventCreateTermSurveyAtBefore',
  components: { GVTag, GJgrowEventCreateFormFormat },
  computed: {},
  methods: {},
  validations: {
    beforeSurveyStartDate: { required },
    beforeSurveyEndDate: { required },
  },
})
export default class GJgrowEventCreateTermSurveyAtBefore extends mixins(GPageBase) {
  isStartDateChange: boolean = false;
  mounted() {}

  get beforeSurveyStartDate(): Date {
    return this.eventParam.beforeSurveyStartDate;
  }

  get beforeSurveyEndDate(): Date {
    return this.eventParam.beforeSurveyEndDate;
  }

  get eventParam(): EventParam {
    return jgrowEventCreateModule.params;
  }

  get isStartDateInvalid(): boolean {
    return this.$v.beforeSurveyStartDate.$dirty && this.$v.beforeSurveyStartDate.$invalid;
  }
  get isStartDateBeforeCurrentTime(): boolean {
    return moment(this.eventParam.beforeSurveyStartDate) <= moment(new Date()).add(-5, 'm');
  }

  get isEndDateInvalid(): boolean {
    return this.$v.beforeSurveyEndDate.$dirty && this.$v.beforeSurveyEndDate.$invalid;
  }

  get isEndDateBeforeStartTime(): boolean {
    return !this.$v.beforeSurveyStartDate.$invalid && !this.$v.beforeSurveyEndDate.$invalid && moment(this.eventParam.beforeSurveyEndDate) <= moment(this.eventParam.beforeSurveyStartDate);
  }

  touchDeadline(): void {
    this.$v.beforeSurveyEndDate.$touch();
  }

  // iviewのDatePickerのoptionsに入れるオブジェクト
  get dateOption() {
    const startDate: Date = globalModule.isNewSchoolYear ? new Date(globalModule.selectedSchoolYear, 3, 1) : new Date();
    return {
      disabledDate(date: Date) {
        //終了日を開始日+1より手前の日付で設定を不可能にする
        return (date && moment(date) < moment(startDate).add(-1, 'd')) || moment(new Date(globalModule.selectedSchoolYear + 1, 3, 1)) <= moment(date);
      },
    };
  }

  // iviewのDatePickerのoptionsに入れるオブジェクト(終了日は無期限)
  get dateForeverOption() {
    const startDate: Date = new Date();
    return {
      disabledDate(date: Date) {
        //終了日を開始日+1より手前の日付で設定を不可能にする
        return date && moment(date) < moment(startDate).add(-1, 'd');
      },
    };
  }

  /**
   * 開始時間変更時
   */
  handleStartDateChange(value: string) {
    this.isStartDateChange = true;
    this.eventParam.beforeSurveyStartDate = value === '' ? null : moment(value).toDate();
    this.$v.beforeSurveyStartDate.$touch();
  }

  /**
   * 終了時間変更時
   */
  handleEndDateChange(value: string) {
    this.eventParam.beforeSurveyEndDate = value === '' ? null : moment(value).toDate();
    this.touchDeadline();
  }

  touch() {
    this.$v.$touch();
  }

  isValid(): boolean {
    return !this.isStartDateInvalid && !this.isEndDateInvalid && !this.isEndDateBeforeStartTime;
  }
}
